export default __webpack_public_path__ + "static/media/image.14a810b9.svg";